import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CocurricularActions } from "../../../Store/CoCurricular/action";
import HeaderBackground from "../../../common/SubpagesBGimage";
import SideNavigation from "../../Menu-sidenavbar/SideNavigation ";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import { useLocation } from "react-router-dom";

function CoCurricular() {
    const location = useLocation();
  const [activeCategory, setActiveCategory] = useState("Co-Curricular");
  const [openKeys, setOpenKeys] = useState([]);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const dispatch = useDispatch();
  const routeNames = {
    "/life-at-campus/co-curricular": {
      menuName: "Life At Campus",
      subMenuName: "Collaboration",
    },
  };

  const { menuName, subMenuName } =
    location.state || routeNames[location.pathname] || {};


  useEffect(() => {
    dispatch({ type: CocurricularActions.GET_COCURRICULAR });
  }, [dispatch]);

  const { CocurricularData } = useSelector((state) => state.CocurricularReducer);

  const CocurricularFront = CocurricularData?.data?.CocurricularFront || [];
  const CocurricularDetail = CocurricularData?.data?.CocurricularDetail || [];

  useEffect(() => {
    if (CocurricularData) {
      setIsLoading(false);
    }
  }, [CocurricularData]);

  const handleThumbnailClick = (cocurricularId) => {
    const detailImages = CocurricularDetail.filter(
      (item) => item.cocurricular_id === cocurricularId
    ).map((item) => ({
      src: item.imagePath,
      opts: { caption: item.name || "Detail Image" },
    }));

    if (detailImages.length > 0) {
      Fancybox.show(detailImages, {
        infinite: true,
        buttons: ["zoom", "close", "fullscreen"],
        loop: true,
      });
    }
  };

  const handleCategoryChange = (category) => {
    setActiveCategory(category);
  };

  return (
    <div>
      <main className="main-bg blog-wrap life-at-campus">
      <HeaderBackground
          menuName={menuName}
          subMenuName={subMenuName}
          handleMenuToggle={() => setIsMenuOpen(!isMenuOpen)}
        />
        <section className="work-stand section-padding sub-bg cocurricular-title">
          <div className="container">
          <div className="bord  d-flex align-items-center">
          <h1 className=" fw-300 heading-submenu-res core-fac-heading-res study-tour-ress overall-submenu-heading">Co-Curricular</h1>
          
          </div>
            <div className="row">
              <div className="filtering col-12 text-center life-at-campus-filtering">
                <div className="filter">
             
                </div>
              </div>
            </div>
            <div className="gallery row stand-marg">
              {isLoading ? (
                <div className="loader-container">
                  <div className="spinner"></div>
                </div>
              ) : CocurricularFront.length > 0 ? (
                CocurricularFront.map((item) => (
                  <div
                    key={item.id}
                    className="col-lg-3 col-md-6 col-sm-12 mb-4"
                    style={{ cursor: "pointer" }}
                    onClick={() => handleThumbnailClick(item.id)}
                  >
                    <div className="archi-card-container mt-30">
                      <div
                        className="archi-card-image-lifeatcampus pro-img"
                        style={{
                          backgroundImage: `url(${item.catagory_image})`,
                        }}
                      ></div>
                      <div className="archi-card-content">
                        <p className="archi-card-author fontWeght-lifeatcampus">
                          {item.catagory_name}
                        </p>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="loader-container">
                  <div className="spinner"></div>
                </div>
              )}
            </div>
          </div>
        </section>
      </main>
      <SideNavigation
        key="Life At Campus"
        isMenuOpen={isMenuOpen}
        handleMenuToggle={() => setIsMenuOpen(!isMenuOpen)}
        openKeys={openKeys}
        onOpenChange={setOpenKeys}
        defaultOpenSubMenu="Life At Campus"
      />
    </div>
  );
}

export default CoCurricular;
